module.exports = __webpack_public_path__ + "static/media/icon-checks.f2a22589.svg";